import { compose } from 'recompose';

import PostsCreate from './PostCreate';

const enhance = compose();

export default enhance(PostsCreate);
